import React, { useEffect, useState, createContext, useContext } from 'react';
import { translations, Locale, Direction } from '../i18n/translations';
type LanguageContextType = {
  locale: Locale;
  direction: Direction;
  t: (key: string) => any;
  setLocale: (locale: Locale) => void;
};
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [locale, setLocaleState] = useState<Locale>('en');
  const [direction, setDirection] = useState<Direction>('ltr');
  useEffect(() => {
    // Update direction based on locale
    const newDirection = locale === 'ar' ? 'rtl' : 'ltr';
    setDirection(newDirection);
    // Update document direction and lang attribute
    document.documentElement.dir = newDirection;
    document.documentElement.lang = locale;
    // Update font family based on locale
    if (locale === 'ar') {
      document.body.style.fontFamily = "'Tajawal', sans-serif";
    } else {
      document.body.style.fontFamily = "'Montserrat', sans-serif";
    }
  }, [locale]);
  const setLocale = (newLocale: Locale) => {
    setLocaleState(newLocale);
    // Update URL without reload if needed, or let the router handle it
    // For now we just manage state, the router wrapper will sync this
  };
  // Helper to get nested translation keys like 'header.about'
  const t = (key: string) => {
    const keys = key.split('.');
    let value: any = translations[locale];
    for (const k of keys) {
      if (value && value[k]) {
        value = value[k];
      } else {
        console.warn(`Translation key missing: ${key} for locale ${locale}`);
        return key;
      }
    }
    return value;
  };
  return <LanguageContext.Provider value={{
    locale,
    direction,
    t,
    setLocale
  }} data-id="element-408">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}